module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row row-wider"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "min-height": "150px"
    }
  }, [(_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Existing Organization")]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.organizationGridSpec.tableData,
      "columns": _vm.organizationGridSpec.columns,
      "options": _vm.organizationGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.editOrganization(props.row)
            }
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        _vm.clearOrganization()
      }
    }
  }, [_vm._v("Add New")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('form', {
    ref: "editForm",
    staticClass: "form form-horizontal",
    attrs: {
      "data-vv-scope": "addOrganization"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.description),
      expression: "organization.description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Organization Name"
    },
    domProps: {
      "value": (_vm.organization.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organization, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Address Street 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.addressStreet1),
      expression: "organization.addressStreet1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Address Street Line 1"
    },
    domProps: {
      "value": (_vm.organization.addressStreet1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organization, "addressStreet1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Address Street 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.addressStreet2),
      expression: "organization.addressStreet2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Address Street Line 2"
    },
    domProps: {
      "value": (_vm.organization.addressStreet2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organization, "addressStreet2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Address Street 3")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.addressStreet3),
      expression: "organization.addressStreet3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Address Street Line 3"
    },
    domProps: {
      "value": (_vm.organization.addressStreet3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organization, "addressStreet3", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("City")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.addressCity),
      expression: "organization.addressCity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.organization.addressCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organization, "addressCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.addressState),
      expression: "organization.addressState"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "State"
    },
    domProps: {
      "value": (_vm.organization.addressState)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organization, "addressState", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Zip")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.addressZip),
      expression: "organization.addressZip"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Zip"
    },
    domProps: {
      "value": (_vm.organization.addressZip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.organization, "addressZip", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Billing Code")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.billingCodeId),
      expression: "organization.billingCodeId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.organization, "billingCodeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.billingCodeList), function(code) {
    return _c('option', {
      key: code.billingCodeId,
      domProps: {
        "value": code.billingCodeId
      }
    }, [_vm._v("\r\n                                    " + _vm._s(code.description) + "\r\n                                ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Shape File Access Restricted?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.isShapeFileRestricted),
      expression: "organization.isShapeFileRestricted"
    }],
    attrs: {
      "id": "shapeFileRestricted",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.organization.isShapeFileRestricted) ? _vm._i(_vm.organization.isShapeFileRestricted, null) > -1 : (_vm.organization.isShapeFileRestricted)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.organization.isShapeFileRestricted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.organization.isShapeFileRestricted = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.organization.isShapeFileRestricted = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.organization, "isShapeFileRestricted", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "shapeFileRestricted"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Client")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.isClient),
      expression: "organization.isClient"
    }],
    attrs: {
      "id": "clientCB",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.organization.isClient) ? _vm._i(_vm.organization.isClient, null) > -1 : (_vm.organization.isClient)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.organization.isClient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.organization.isClient = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.organization.isClient = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.organization, "isClient", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "clientCB"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Consultant")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.isConsultant),
      expression: "organization.isConsultant"
    }],
    attrs: {
      "id": "consultantCB",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.organization.isConsultant) ? _vm._i(_vm.organization.isConsultant, null) > -1 : (_vm.organization.isConsultant)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.organization.isConsultant,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.organization.isConsultant = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.organization.isConsultant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.organization, "isConsultant", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "consultantCB"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("BLM Field Office")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.isBlmFieldOffice),
      expression: "organization.isBlmFieldOffice"
    }],
    attrs: {
      "id": "blmFieldOfficeCB",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.organization.isBlmFieldOffice) ? _vm._i(_vm.organization.isBlmFieldOffice, null) > -1 : (_vm.organization.isBlmFieldOffice)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.organization.isBlmFieldOffice,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.organization.isBlmFieldOffice = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.organization.isBlmFieldOffice = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.organization, "isBlmFieldOffice", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "blmFieldOfficeCB"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("BLM District Office")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.isBlmDistrictOffice),
      expression: "organization.isBlmDistrictOffice"
    }],
    attrs: {
      "id": "blmDistrictOfficeCB",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.organization.isBlmDistrictOffice) ? _vm._i(_vm.organization.isBlmDistrictOffice, null) > -1 : (_vm.organization.isBlmDistrictOffice)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.organization.isBlmDistrictOffice,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.organization.isBlmDistrictOffice = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.organization.isBlmDistrictOffice = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.organization, "isBlmDistrictOffice", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "blmDistrictOfficeCB"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("BLM State Office")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.isBlmStateOffice),
      expression: "organization.isBlmStateOffice"
    }],
    attrs: {
      "id": "blmStateOfficeCB",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.organization.isBlmStateOffice) ? _vm._i(_vm.organization.isBlmStateOffice, null) > -1 : (_vm.organization.isBlmStateOffice)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.organization.isBlmStateOffice,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.organization.isBlmStateOffice = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.organization.isBlmStateOffice = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.organization, "isBlmStateOffice", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "blmStateOfficeCB"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("USFS Field Office")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.isUsfsFieldOffice),
      expression: "organization.isUsfsFieldOffice"
    }],
    attrs: {
      "id": "usfsFieldOfficeCB",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.organization.isUsfsFieldOffice) ? _vm._i(_vm.organization.isUsfsFieldOffice, null) > -1 : (_vm.organization.isUsfsFieldOffice)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.organization.isUsfsFieldOffice,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.organization.isUsfsFieldOffice = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.organization.isUsfsFieldOffice = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.organization, "isUsfsFieldOffice", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "usfsFieldOfficeCB"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("USFS Regional Office")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.isUsfsRegionOffice),
      expression: "organization.isUsfsRegionOffice"
    }],
    attrs: {
      "id": "usfsRegionOfficeCB",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.organization.isUsfsRegionOffice) ? _vm._i(_vm.organization.isUsfsRegionOffice, null) > -1 : (_vm.organization.isUsfsRegionOffice)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.organization.isUsfsRegionOffice,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.organization.isUsfsRegionOffice = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.organization.isUsfsRegionOffice = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.organization, "isUsfsRegionOffice", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "usfsRegionOfficeCB"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Lead Agency")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.isLeadAgency),
      expression: "organization.isLeadAgency"
    }],
    attrs: {
      "id": "leadAgencyCB",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.organization.isLeadAgency) ? _vm._i(_vm.organization.isLeadAgency, null) > -1 : (_vm.organization.isLeadAgency)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.organization.isLeadAgency,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.organization.isLeadAgency = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.organization.isLeadAgency = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.organization, "isLeadAgency", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "leadAgencyCB"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("106 Agency")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.is106Agency),
      expression: "organization.is106Agency"
    }],
    attrs: {
      "id": "onezerosixCB",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.organization.is106Agency) ? _vm._i(_vm.organization.is106Agency, null) > -1 : (_vm.organization.is106Agency)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.organization.is106Agency,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.organization.is106Agency = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.organization.is106Agency = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.organization, "is106Agency", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "onezerosixCB"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Agency No Review")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.agencyNoReview),
      expression: "organization.agencyNoReview"
    }],
    attrs: {
      "id": "reviewingAgencyCB",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.organization.agencyNoReview) ? _vm._i(_vm.organization.agencyNoReview, null) > -1 : (_vm.organization.agencyNoReview)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.organization.agencyNoReview,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.organization.agencyNoReview = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.organization.agencyNoReview = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.organization, "agencyNoReview", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "reviewingAgencyCB"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Federal Agency")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.isFederalAgency),
      expression: "organization.isFederalAgency"
    }],
    attrs: {
      "id": "fedAgencyCB",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.organization.isFederalAgency) ? _vm._i(_vm.organization.isFederalAgency, null) > -1 : (_vm.organization.isFederalAgency)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.organization.isFederalAgency,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.organization.isFederalAgency = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.organization.isFederalAgency = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.organization, "isFederalAgency", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "fedAgencyCB"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Users")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.userGridSpec.tableData,
      "columns": _vm.userGridSpec.columns,
      "options": _vm.userGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.goUser(props.row)
            }
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.addOrganization
    }
  }, [_vm._v("Save")])])])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Organization")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Organization")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a160e96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Organization.vue
// module id = 932
// module chunks = 1